import { FC } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface Props {
  isExtension?: boolean;
  isScript?: boolean;
}

const SiteLoader: FC<Props> = ({ isExtension, isScript }: Props): JSX.Element => {
  return (
    <div
      className={classNames(styles.container, {
        [styles['extension']]: isExtension,
        [styles['script']]: isScript,
      })}
      role={'status'}
      aria-live={'polite'}>
      <div className={styles.lds_ring} role={'progressbar'} aria-label={'Loading'} aria-busy={'true'} tabIndex={0}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default SiteLoader;
